export default __webpack_public_path__ + "./img/livekasmbg.18a1e6516220deb4876bd8533e03cd76.png";